var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 49.882,
    viewBox: "0 0 120 49.882",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(-57.6 -57.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M115.2,189.427V172.8h24.941a8.314,8.314,0,1,1,0,16.627Z",
    transform: "translate(-40.973 -81.945)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 16.627,
    height: 16.627,
    transform: "translate(90.855 57.6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(124.11 74.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M290.638,115.2H288v16.628h10.354v-2.439h-7.716Z",
    transform: "translate(-288 -115.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M338.061,137.4l0-2.508c0-2.939-1.946-4.764-5.078-4.764a7.08,7.08,0,0,0-4.269,1.32l-.055.044v2.43l.242-.209a5.887,5.887,0,0,1,3.767-1.3c1.929,0,2.866.88,2.866,2.691v.135h-3.447a5.344,5.344,0,0,0-3.812,1.311,3.3,3.3,0,0,0-.977,2.4c0,2.244,1.9,3.874,4.519,3.874a4.564,4.564,0,0,0,3.717-1.672v1.3h2.582l-.006-.152C338.051,140.889,338.057,138.789,338.061,137.4Zm-5.975,3.207c-1.366,0-2.284-.714-2.284-1.776,0-1.039.921-1.636,2.527-1.636h3.207v.206A3.38,3.38,0,0,1,332.086,140.607Z",
    transform: "translate(-315.955 -125.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M378.1,130.156a4.57,4.57,0,0,0-4.087,2.315v-1.966H371.5V146.9h2.517v-5.973a4.558,4.558,0,0,0,3.821,1.889c3.242,0,5.685-2.761,5.685-6.424C383.522,132.779,381.243,130.156,378.1,130.156Zm2.854,6.33c0,2.453-1.438,4.1-3.579,4.1-2.072,0-3.41-1.573-3.41-4.008,0-2.481,1.409-4.148,3.507-4.148S380.957,134.061,380.957,136.486Z",
    transform: "translate(-347.395 -125.839)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 2.517,
    height: 11.96,
    transform: "translate(37.963 4.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M442.476,130.156a4.347,4.347,0,0,0-3.869,1.908v-1.558h-2.517v11.96h2.517V136.02c0-2.339,1.137-3.681,3.12-3.681,1.838,0,2.587.911,2.587,3.144v6.984h2.517v-7.45C446.83,132.018,445.162,130.156,442.476,130.156Z",
    transform: "translate(-393.34 -125.839)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 2.797,
    height: 2.798,
    transform: "translate(37.823 0)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M74.227,90.855H57.6V65.914a8.314,8.314,0,0,1,16.627,0Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.83791ae0fe0615e6af9fbe211f16563d.svg";
export { ForwardRef as ReactComponent };